<template>
  <div class="articles-section__root">
    <template v-if="hasArticles">
      <!-- <div class="articles-section__container">
        <div class="articles-section__header">
          <span class="articles-section__label">{{ t('blog.label') }}</span>
          <h2 class="articles-section__title">{{ t('blog.title') }}</h2>
        </div>
        <div class="articles-section__grid">
          <ArticleCard
            v-for="article in displayArticles"
            :key="article.id"
            :slug="article.article_slug"
            :title="article.article_title"
            :image="article.article_image || '/assets/images/placeholder-article.png'"
            :author-name="article.article_author?.name || ''"
            :date="formatLocalizedDate(article.article_created_at ?? article.article_modified_at, props.locale)"
          />
        </div>
        <div class="articles-section__footer">
          <NuxtLink :to="articlesListHref" class="articles-section__link">
            <UIButton
              variant="primary-arrow"
              arrow-direction="right"
              :text="t('blog.showMore')"
              :outline="false"
              padding="18px 35px"
              rounded="8px"
              size="large"
            />
          </NuxtLink>
        </div>
      </div> -->
    </template>
    <template v-else-if="loading">
      <div class="articles-section__container">
        <div class="articles-section__header">
          <span class="articles-section__label">{{ t('blog.label') }}</span>
          <h2 class="articles-section__title">{{ t('blog.title') }}</h2>
        </div>
        <div class="articles-section__grid" aria-hidden="true">
          <ArticleCardSkeleton v-for="i in 3" :key="i" />
        </div>
      </div>
    </template>
    <template v-else>
      <!-- No articles -->
    </template>
  </div>
</template>

<script setup lang="ts">
import { useArticle } from '@/composables/article'
import { buildArticlesPath } from '@/composables/locale/useIndexRoutes'
import { HOME_ARTICLES_LIMIT } from '@/utils/articles.helpers'
import { formatLocalizedDate } from '@/utils/date.helpers'

const props = defineProps<{
  locale: string
}>()

const { t } = useI18n()
const {
  articles,
  loading,
  hasArticles,
  fetchArticles,
} = useArticle()

const articlesListHref = computed(() => buildArticlesPath(props.locale))
const displayArticles = computed(() => articles.value.slice(0, HOME_ARTICLES_LIMIT))

onMounted(async () => {
  await fetchArticles({
    article_locale: props.locale,
    limit: HOME_ARTICLES_LIMIT,
  }, false)
})

watch(() => props.locale, async (newLocale) => {
  await fetchArticles({
    article_locale: newLocale,
    limit: HOME_ARTICLES_LIMIT,
  }, false)
})
</script>

<style scoped>
.articles-section__root {
  width: 100%;
}

.articles-section__container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 95px 40px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.articles-section__header {
  margin-bottom: 48px;
  text-align: center;
}

.articles-section__label {
  display: block;
  font-family: var(--font-inter);
  font-size: var(--font-size-body);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-teal, #0d9488);
  margin-bottom: 12px;
}

.articles-section__title {
  font-family: var(--font-inter);
  font-weight: 700;
  font-size: 52px;
  line-height: 1.2;
  color: var(--color-dark-blue);
  margin: 0;
}

.articles-section__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
}

.articles-section__footer {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}

.articles-section__link {
  text-decoration: none;
}

@media (max-width: 1400px) {
  .articles-section__container {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media (max-width: 991px) {
  .articles-section__container {
    padding: 60px 30px 64px;
  }

  .articles-section__title {
    font-size: 36px;
  }

  .articles-section__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 767px) {
  .articles-section__container {
    padding: 40px 20px 48px;
  }

  .articles-section__title {
    font-size: 32px;
  }

  .articles-section__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .articles-section__footer {
    padding-top: 32px;
  }
}

@media (max-width: 575px) {
  .articles-section__header {
    margin-bottom: 32px;
  }

  .articles-section__title {
    font-size: 28px;
  }
}
</style>
